export default __webpack_public_path__ + "static/media/Conceptual_Architecture.daa14a10.png";